/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { withLocalization } from 'hocs/localization'
import { onStartLogoutWithRedirect } from 'redux-app/actionCreators/auth'
import { getUserDetails, isUserAbleToOpenProfile } from 'redux-app/selectors/user'
import UserControls from './UserControls'

export default compose(
  withLocalization('header.userControls'),
  connect(
    (state, { t }) => {
      const userDetails = getUserDetails(state) || EMPTY_OBJECT
      if (userDetails.firstName !== '') {
        return {
          greeting: `${t('hello')}, ${userDetails.firstName}`,
          isUserAbleToOpenProfile: isUserAbleToOpenProfile(state),
        }
      }

      return {
        greeting: `${t('hello')}`,
        isUserAbleToOpenProfile: isUserAbleToOpenProfile(state),
      }

    },
    {
      onLogout: onStartLogoutWithRedirect,
    },
  ),
  withRouter,
)(UserControls)
